import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiGet } from 'api-service';
import { getResourceSearchFullText } from 'utils';

export const fetchFilterResources = createAsyncThunk(
  'resourceReducer/fetchFilterResources',
  async ({ searchQuery, params, path, platforms }, thunkAPI) => {
    try {
      const response = await apiGet(path, {
        sort_type: 'desc',
        ...params,
        count: 10,
        q: searchQuery,
        page: 1,
        full_text: getResourceSearchFullText(searchQuery),
        platforms,
      });
      return response.data.result.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const resourcesInitial = {
  data: [],
  loading: false,
  error: null,
};

const initialState = {
  filterResources: {
    news: resourcesInitial,
    instagram: resourcesInitial,
    instagram_comment: resourcesInitial,
    telegram: resourcesInitial,
    twitter: resourcesInitial,
    newspaper: resourcesInitial,
    kiosk: resourcesInitial,
    nativePlatforms: resourcesInitial,
    linkedin: resourcesInitial,
    bale: resourcesInitial,
    eitaa: resourcesInitial,
    rubika: resourcesInitial,
    virasty: resourcesInitial,
  },
  selectedResources: {},
  selectedResourcesLoading: false,
};

export const resourceSlice = createSlice({
  name: 'resourceSlice',
  initialState,
  reducers: {
    resetFilterResources: (state) => {
      state.filterResources = initialState.filterResources;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFilterResources.fulfilled, (state, action) => {
        const platform = action.meta.arg.parentPlatform;
        if (platform) {
          state.filterResources[platform].data = action.payload;
          state.filterResources[platform].loading = false;
          state.filterResources[platform].error = null;
          return;
        }
        state.selectedResources = action.payload.reduce((acc, item) => {
          acc[item.id] = item;
          return acc;
        }, {});
        state.selectedResourcesLoading = false;
      })
      .addCase(fetchFilterResources.pending, (state, action) => {
        const platform = action.meta.arg.parentPlatform;
        if (platform) {
          state.filterResources[platform].loading = true;
          state.filterResources[platform].error = null;
          return;
        }
        state.selectedResourcesLoading = true;
      })
      .addCase(fetchFilterResources.rejected, (state, action) => {
        const platform = action.meta.arg.parentPlatform;
        if (platform) {
          state.filterResources[platform].loading = false;
          state.filterResources[platform].error = action.payload;
          return;
        }
        state.selectedResourcesLoading = false;
      });
  },
});

export const { resetFilterResources } = resourceSlice.actions;
